<template>
  <div class="params-passage-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置</el-button>
        </el-button-group>
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" size="mini"
                     type="primary" icon="el-icon-plus">新增过道
          </el-button>
          <el-button @click="clickEdit" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="del" size="mini" type="primary"
                     icon="el-icon-delete">删除
          </el-button>
          <el-button @click="setLeftUp" size="mini"
                     type="primary" icon="el-icon-map-location">设置左/上座标点
          </el-button>
          <el-button @click="setRightBottom" size="mini"
                     type="primary" icon="el-icon-map-location">设置右/下座标点
          </el-button>
          <el-button @click="setBaseStation" size="mini"
                     type="primary" icon="el-icon-s-tools">包含基站
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="所在甲板" prop="deck"></el-table-column>
        <el-table-column label="横向纵向">
          <template slot-scope="scope">
            <span v-if="scope.row.direction=='horizontal'">横向</span>
            <span v-if="scope.row.direction=='vertical'">纵向</span>
          </template>
        </el-table-column>
        <el-table-column label="左/上座标点" align="center" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.left_up.through==false">不通行</span>
            <el-button v-if="scope.row.left_up.through&&scope.row.left_up.point.x!=0" size="mini"
                       type="primary" plain>已设置
            </el-button>
            <el-button v-if="scope.row.left_up.through&&scope.row.left_up.point.x==0"
                       size="mini" type="warning" plain>未设置
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="右/下座标点" align="center" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.right_bottom.through==false">不通行</span>
            <el-button v-if="scope.row.right_bottom.through&&scope.row.right_bottom.point.x!=0"
                       size="mini" type="primary" plain>已设置
            </el-button>
            <el-button v-if="scope.row.right_bottom.through&&scope.row.right_bottom.point.x==0"
                       size="mini" type="warning" plain>未设置
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="包含基站" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain>已设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog class="dialog-map" title="设置座标点" width="80%" :visible.sync="setPointDialogIsShow">
      <div style="width:100%;height:400px;">
        <v-ship-map-set-area ref="shipmap" @transmit="transmit"
                             containerHeight="400"
                             :shipMapData="dataToMap"
                             :ship_img="ship_img">
        </v-ship-map-set-area>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="emptyData">清空</el-button>
        <el-button size="mini" type="primary" @click="submitPassagePoint">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">所在甲板</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'甲板1',label:'甲板1'},{value:'甲板2',label:'甲板2'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">横向纵向</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择横向纵向">
            <el-option
                v-for="item in [{value:'横向',label:'横向'},{value:'纵向',label:'纵向'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">左/上</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'可通行',label:'可通行'},{value:'禁止通行',label:'禁止通行'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">右/下</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'可通行',label:'可通行'},{value:'禁止通行',label:'禁止通行'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock.js';
  import ShipMapSetArea from '../../components/ship-map-set-area.vue';
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        setPointDialogIsShow: false,
        dataToMap: {},
        dataFromMap: {},
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    methods: {
      submitPassagePoint(){
        console.log(this.dataFromMap);
        alert('保存数据');
        this.setPointDialogIsShow = false;
      },

      transmit(data){
        console.log(JSON.stringify(data));
        this.dataFromMap = data;
      },

      emptyData(){
        this.$refs.shipmap.drawOnePointEsc();
      },

      setLeftUp(){
        console.log(this.currentRow);
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else if (this.currentRow.left_up.through === false) {
          tool.message('左/上禁止通行，无需设置', 'warning');
        } else {
          this.setPointDialogIsShow = true;
          this.dataToMap = {
            type: 'setOnePoint',
            data: {
              id: this.currentRow.id,
              direction: this.currentRow.direction,
              point: this.currentRow.left_up.point
            }
          };
          setTimeout(() => {
            this.$refs.shipmap.load();
          }, 10);
        }
      },

      setRightBottom(){
        console.log(this.currentRow);
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else if (this.currentRow.right_bottom.through === false) {
          tool.message('左/上禁止通行，无需设置', 'warning');
        } else {
          this.setPointDialogIsShow = true;
          this.dataToMap = {
            type: 'setOnePoint',
            data: {
              id: this.currentRow.id,
              direction: this.currentRow.direction,
              point: this.currentRow.right_bottom.point
            }
          };
          setTimeout(() => {
            this.$refs.shipmap.load();
          }, 10);
        }
      },

      setBaseStation(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        alert('设置基站，和前面“船舱总段”一样');
      },

      setMap(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.$router.push({path: "/monitoring/realtime"});
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },

      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },

      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },

      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },

      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        this.tableLoading = false;
        this.pagination.total = mock.passage.length;
        this.list = mock.passage;
      },

      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },

      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },

      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {
      'v-ship-map-set-area': ShipMapSetArea
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../../common/less/ship-map.less";

  .params-passage-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
  }
</style>
